import * as React from 'react'
import { FC } from 'react'
import { IDiscountLineItem } from '@user/store/discountCode/typings'
import { DiscountLineItemWrapper } from '../DiscountLineItemWrapper'

interface Props {
  lineItems: IDiscountLineItem[]
}

export const DiscountLineItemCardList: FC<Props> = (props) => {
  const { lineItems } = props

  return (
    <>
      {lineItems.map((item, index) => (
        <DiscountLineItemWrapper discountLineItem={item} key={index} />
      ))}
    </>
  )
}
